import "react-datepicker/dist/react-datepicker.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-tooltip/dist/react-tooltip.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "moment/locale/pt-br";
import "./styles/colors.css";

import React from "react";
import moment from "moment";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "styled-components";
import { GoogleOAuthProvider } from "@react-oauth/google";

import GlobalStyle from "./styles/globalStyles";
import theme from "./styles/theme";
import App from "./app";
import LoaderProvider from "./providers/LoaderProvider";
import AuthProvider from "./providers/AuthProvider";
import MenuProvider from "./providers/MenuProvider";

moment.locale("pt-br");

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}
    >
      <AuthProvider>
        <LoaderProvider>
          <MenuProvider>
            <GlobalStyle />
            <App />
          </MenuProvider>
        </LoaderProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  </ThemeProvider>
  // </React.StrictMode>
);
